import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class BootstrapLoaderService {
  private platformId = inject(PLATFORM_ID);
  private loaded = false;

  load(): void {
    if (!isPlatformBrowser(this.platformId) || this.loaded) return;
    if (document.querySelector('script[data-bootstrap]')) { this.loaded = true; return; }
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js';
    script.defer = true;
    script.setAttribute('data-bootstrap', '');
    document.head.appendChild(script);
    this.loaded = true;
  }
}
